import {
  Input as InputBase,
  InputProps as InputBaseProps
} from '@unistocks/components/basic/input';
import { ViewProps } from 'tamagui';

export type InputProps = InputBaseProps & {
  iconAfter?: React.ReactNode;
  appendText?: string;
  renderRight?: React.ReactNode;
  invalid?: boolean;
  contentContainerProps?: ViewProps;
};

export const Input: React.FC<InputProps> = ({
  ref,
  iconAfter,
  appendText,
  renderRight,
  disabled,
  invalid,
  contentContainerProps,
  ...props
}) => {
  return (
    <InputBase disabled={disabled} invalid={invalid} {...contentContainerProps}>
      <InputBase.Box>
        <InputBase.Section>
          <InputBase.Area ref={ref} {...props} />
        </InputBase.Section>
        {iconAfter ? (
          <InputBase.Section>
            <InputBase.Icon>{iconAfter}</InputBase.Icon>
          </InputBase.Section>
        ) : null}
        {appendText ? (
          <InputBase.Section>
            <InputBase.AppendText>{appendText}</InputBase.AppendText>
          </InputBase.Section>
        ) : null}
        {renderRight ? <InputBase.Section>{renderRight}</InputBase.Section> : null}
      </InputBase.Box>
    </InputBase>
  );
};
